import { te } from "../../../../date-fns/locale/te.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    te
  }
};